import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell
} from 'recharts';
import { Paper, Typography, Skeleton } from '@mui/material';
import { formatMoney } from '../../../utils/currency';

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const { name, average } = payload[0].payload;
  return (
    <div style={{ backgroundColor: '#fff', padding: 10, borderRadius: 4, boxShadow: '0 0 5px rgba(0,0,0,0.2)' }}>
      <Typography variant="subtitle2">{name}</Typography>
      <Typography variant="body2">🎟️ Ticket promedio: {formatMoney(average)}</Typography>
    </div>
  );
};

const AverageTicketByBranchChart = ({ data, branches = [], loading }) => {
  const getColor = (branchId) =>
    branches.find((b) => b.id === branchId)?.color || '#ccc';

  return (
    <Paper elevation={2} sx={{ p: 2, height: 340 }}>
      <Typography variant="subtitle1" gutterBottom>
        Ticket promedio por sucursal
      </Typography>
      {loading ? (
        <Skeleton variant="rectangular" height={300} />
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
            <XAxis dataKey="branchId" tickFormatter={(id) => (() => { const b = branches.find((x) => x.id === id); return b ? (b.deleted ? `${b.name} (eliminada)` : b.name) : id; })()} />
            <YAxis />
            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="average">
              {data.map((entry, index) => (
                <Cell
                  key={index}
                  fill={getColor(entry.branchId)}
                  fillOpacity={branches.find((b) => b.id === entry.branchId)?.deleted ? 0.4 : 1}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </Paper>
  );
};

export default AverageTicketByBranchChart;
